import { useMutation } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { createCheckout } from "~/lib/checkout/create-checkout";

/**
 * Hook that provides checkout functionality for offers.
 * Automatically handles the mutation state and error handling.
 */
export function useOfferCheckout() {
  const createCheckoutFn = useServerFn(createCheckout);

  const createCheckoutMutation = useMutation({
    mutationFn: (offerId: string) => createCheckoutFn({ data: { offerId } }),
    onSuccess: (result) => {
      if (result.checkoutUrl) {
        window.location.href = result.checkoutUrl;
      }
    },
  });

  return {
    createCheckout: createCheckoutMutation,
  };
}
